import React from 'react';
import Calendar from 'react-multi-date-picker';

export default function DatePicker({
  name,
  value,
  onChange,
  allowMulti
}) {

  let localValue = value || new Date();

  const onUpdate = (val) => {
    if (Array.isArray(val)) {
      onChange(val.map(value => value.toDate()), name);
    } else {
      onChange(val.toDate(), name);
    }
  }

  return (
    <Calendar
      value={localValue}
      multiple={allowMulti}
      onChange={onUpdate}
      inputClass="multi-date-picker"
      containerClassName="multi-date-picker-container"
      format="dddd, MMM D, YYYY"
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/form/DatePickerMulti.js